import { render, staticRenderFns } from "./KanbanList.vue?vue&type=template&id=545f8df9&scoped=true"
import script from "./KanbanList.vue?vue&type=script&lang=ts"
export * from "./KanbanList.vue?vue&type=script&lang=ts"
import style0 from "./KanbanList.vue?vue&type=style&index=0&id=545f8df9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545f8df9",
  null
  
)

export default component.exports